import Sparkline from "./Sparkline";
import InfoButton, { type InfoContent } from "./InfoButton";
import { materialTiles } from "../lib/derive";

interface Props {
  info?: InfoContent;
}

export default function MaterialStrip({ info }: Props) {
  return (
    <div className="material-strip">
      <div className="material-strip-head">
        <div>
          <div className="card-eyebrow">K-101 · K-103-106 · ADVANCED</div>
          <div className="material-strip-title">Material commodity spike monitor</div>
        </div>
        {info && <InfoButton info={info} />}
      </div>
      <div className="material-grid">
        {materialTiles.map((m) => {
          const flagCls =
            m.flag === "SPIKE" ? "spike-bad" : m.flag === "WATCH" ? "spike-warn" : "";
          const flagBg =
            m.flag === "SPIKE" ? "rgba(220,38,38,0.18)" :
            m.flag === "WATCH" ? "rgba(217,119,6,0.18)" :
            "rgba(5,150,105,0.14)";
          const flagFg =
            m.flag === "SPIKE" ? "var(--critical)" :
            m.flag === "WATCH" ? "var(--warning)" :
            "var(--good)";
          const deltaColor =
            m.deltaDirection === "good" ? "var(--good)" :
            m.deltaDirection === "warn" ? "var(--warning)" :
            m.deltaDirection === "bad" ? "var(--critical)" :
            "var(--t3)";
          return (
            <div key={m.id} className={`material-tile ${flagCls}`}>
              <div className="material-tile-head">
                <div className="material-tile-name">{m.name}</div>
                <span
                  className="material-tile-flag"
                  style={{ background: flagBg, color: flagFg }}
                >
                  {m.flag}
                </span>
              </div>
              <div className="material-tile-row">
                <div>
                  <span className="material-tile-val">{m.latest}</span>
                  <span style={{ fontSize: 10, color: "var(--t4)", marginLeft: 4 }}>{m.unit}</span>
                </div>
                <div className="material-tile-delta" style={{ color: deltaColor }}>
                  {m.delta}
                </div>
              </div>
              <Sparkline
                values={m.spark}
                direction={m.deltaDirection as any}
                className="material-tile-spark"
                viewBox="0 0 200 30"
              />
              <div className="material-tile-z">
                {m.id} · z = {m.z >= 0 ? "+" : ""}{m.z.toFixed(1)}σ
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
